<template>
  <b-card style="max-width: 900px; min-width: 300px; margin: auto;">
    <b-card-text class="mb-5">
      <div class="d-flex flex-column align-items-center">
        <transition name="slide-fade-up">
          <router-link :to="redirectTo">
            <b-img
              :src="require('@/assets/images/logo_centered.svg')"
              width="300"
              class="rounded-0 mb-5"
          /></router-link>
        </transition>

        <h1>Frequently Asked Questions</h1>
        <b-row class="mt-3">
          <b-col>
            <p v-html="faq"></p>
          </b-col>
        </b-row>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import Cookies from 'js-cookie'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('user', {
      token: 'token'
    }),
    ...mapState('faq', {
      faq: 'faq'
    }),

    redirectTo() {
      return Cookies.get('AUTH_TOKEN') ? '/dashboard' : '/login'
    }
  },
  created() {
    this.$store.dispatch('faq/getFaq')
  }
}
</script>
<style lang="scss" scoped>
.card {
  box-shadow: none;
}
</style>
